import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { StatusStateEnum } from "~/types/enums";
import { Button, Icon, InputText, Modal, Text } from "~/components-shared";
import communitySelectors from "~/store/communities/selectors";
import communitiesActionCreators from "~/store/communities/actions";
import styled, { useTheme } from "styled-components";
import ManageCommunitiesItemCard from "~/components/ManageCommunitiesItemCard";
const List = styled.div`
  overflow: auto;
  padding-right: 1em;
`;
const ManageCommunitiesModal = _ref => {
  let {
    onClose
  } = _ref;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const communities = useSelector(communitySelectors.getCommunities);
  const status = useSelector(communitySelectors.getStatus);
  const filter = useSelector(communitySelectors.getFilter);
  const dispatch = useDispatch();
  useEffect(() => {
    if (status === StatusStateEnum.IDLE) {
      dispatch(communitiesActionCreators.fetchStarted());
    }
  }, [status, dispatch]);
  const handleFilter = newFilter => {
    dispatch(communitiesActionCreators.filtered(newFilter));
  };
  const handleClose = () => {
    if (filter?.query !== "") {
      handleFilter({
        ...filter,
        query: ""
      });
    }
    onClose();
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    maxWidth: "500px",
    fullWidth: true,
    onClose: handleClose,
    title: t("ProfileCommunities.manageCommunities")
  }, /*#__PURE__*/React.createElement(Modal.Content, {
    minHeight: "70vh",
    fullHeight: true
  }, /*#__PURE__*/React.createElement(InputText, {
    s: {
      mb: 5
    },
    value: filter?.query || "",
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: "search",
      s: {
        mr: 2
      }
    }),
    placeholder: t("common.actions.search"),
    color: colors.background.primary,
    onChange: value => handleFilter({
      ...filter,
      query: value
    }),
    clearButton: true
  }), communities.length ? /*#__PURE__*/React.createElement(List, null, communities.map(community => /*#__PURE__*/React.createElement(ManageCommunitiesItemCard, {
    key: community.id,
    community: community
  }))) : /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 5,
    align: "center",
    display: "block"
  }, t("ManageCommunities.noCommunities"))), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleClose,
    rounded: true,
    display: "inline-block"
  }, t("common.actions.close"))));
};
export default ManageCommunitiesModal;